module.exports = __webpack_public_path__ + "img/template_einvoice_customer.56efe97b.svg";